export default __webpack_public_path__ + "static/media/clinetTen.c10160a6.png";